export default __webpack_public_path__ + "static/media/hero-level-5-bg.01502829.webp";